import { render, staticRenderFns } from "./ChurchNew.vue?vue&type=template&id=d1cf8076"
import script from "./ChurchNew.vue?vue&type=script&lang=js"
export * from "./ChurchNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports